export * from './pricesDetailComponent';